import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=53cfa09c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=53cfa09c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfa09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53cfa09c')) {
      api.createRecord('53cfa09c', component.options)
    } else {
      api.reload('53cfa09c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=53cfa09c&scoped=true&", function () {
      api.rerender('53cfa09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/comp/DocBox.vue"
export default component.exports